import { create } from "zustand";
import { ViewWLSubscriptionsTiers } from "../../../Common/models/subscriptions";

interface ReferredBonusEntries {
  referedBonusEntries: {
    title: string;
    value: number;
    promoText: string;
  };
  twoWayBonusEntries: {
    title: string;
    value: number;
    promoText: string;
  };
  referedTotalEntries: number;
}

interface WebSignUpState {
  selectedSubscription: undefined | null | ViewWLSubscriptionsTiers;
  setSelectedSubscription: (value: null | ViewWLSubscriptionsTiers) => void;

  subscriptionList: ViewWLSubscriptionsTiers[] | undefined;
  setSubscriptionList: (value: ViewWLSubscriptionsTiers[]) => void;

  referredBonusEntries: undefined | ReferredBonusEntries;
  setReferredBonusEntries: (value: undefined | ReferredBonusEntries) => void;
}

const useWebReferralStore = create<WebSignUpState>((set) => ({
  selectedSubscription: undefined,
  setSelectedSubscription: (selectedSubscription) =>
    set({ selectedSubscription }),

  subscriptionList: undefined,
  setSubscriptionList: (subscriptionList) => set({ subscriptionList }),

  referredBonusEntries: undefined,
  setReferredBonusEntries: (referredBonusEntries) =>
    set({ referredBonusEntries }),
}));

export default useWebReferralStore;
